import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { ROUTES } from '../constants/routes'
import { somethingWentWrong } from '../lib/helpers/miscHelpers'
import { sessionService } from '../lib/services/sessionService'

export function useLogoutMutation() {
  return useMutation({
    mutationFn: () => sessionService.logout(),
    onSuccess: () => {
      toast.success('Logged out')
      window.location.assign(ROUTES.login)
    },
    onError: somethingWentWrong,
  })
}
